// Journal des livraisons. Chaque entrée correspond à du code réellement déployé.
export const CATEGORIES = {
  new: { label: "Nouveau", tone: "new" },
  improvement: { label: "Amélioration", tone: "imp" },
  fix: { label: "Correctif", tone: "fix" },
  security: { label: "Sécurité", tone: "sec" },
  performance: { label: "Performance", tone: "perf" },
};

export const ENTRIES = [
  {
    date: "2026-09-16", title: "Centre de confiance, documentation et pages légales",
    categories: ["new"],
    summary: "Un footer complet, un Trust Center, une documentation développeur et l'ensemble des documents juridiques.",
    points: [
      "Trust Center détaillant chaque mesure de sécurité réellement en place, et celles qui manquent encore.",
      "Documentation de l'API : authentification, référence des endpoints, erreurs et limites de débit.",
      "Neuf documents juridiques, du contrat d'utilisation à la charte d'usage acceptable.",
      "Page d'état qui interroge réellement l'API et la base à chaque chargement.",
      "Bandeau cookies avec refus aussi accessible que l'acceptation.",
    ],
  },
  {
    date: "2026-09-16", title: "Connexion sans mot de passe",
    categories: ["new", "security"],
    summary: "Les mots de passe disparaissent au profit d'un lien de connexion à usage unique.",
    points: [
      "Lien valable 15 minutes, inutilisable après la première ouverture.",
      "Plus aucun mot de passe stocké : il n'y a plus rien à voler de ce côté.",
      "Le compte est créé à la première ouverture du lien, sans formulaire d'inscription.",
      "Les comptes créés sous l'ancien modèle ont été supprimés.",
    ],
  },
  {
    date: "2026-09-16", title: "Onboarding en trois étapes",
    categories: ["new"],
    summary: "Profil, jeu et objectif — puis une liste de prise en main sur le tableau de bord.",
    points: [
      "Photo de profil redimensionnée dans le navigateur avant envoi.",
      "Paliers proposés selon le jeu choisi, et non une liste générique.",
      "Six étapes de prise en main suivies sur le tableau de bord.",
    ],
  },
  {
    date: "2026-09-16", title: "Page d'accueil publique",
    categories: ["new"],
    summary: "Une landing qui s'adresse à égalité aux joueurs et aux coachs.",
    points: [
      "Deux parcours distincts dès le premier écran.",
      "Foire aux questions accessible au clavier, sans JavaScript.",
      "Mouvement réduit respecté pour les personnes qui le demandent.",
    ],
  },
  {
    date: "2026-09-16", title: "Durcissement de l'API",
    categories: ["security"],
    summary: "Vérification d'origine, limitation de débit et en-têtes de sécurité.",
    points: [
      "Toute requête modifiante exige une origine connue, sinon 403.",
      "Limitation par IP sur les points d'entrée d'authentification.",
      "CSP, HSTS, X-Frame-Options, Referrer-Policy et Permissions-Policy sur toutes les réponses.",
      "Documentation OpenAPI désactivée en production.",
    ],
  },
];
